import { Dimensions, Platform } from 'react-native';

import { YStack } from 'tamagui';

import { HeadingS } from '@south-street-app/atoms';

const MaintenanceBottomSheetContent = () => {
  const screenHeight = Dimensions.get('window').height;

  const height = Platform.OS === 'web' ? screenHeight : screenHeight * 0.9;

  return (
    <YStack
      height={height}
      justifyContent={'center'}
      alignItems={'center'}
      paddingHorizontal={'$4'}
    >
      <HeadingS textAlign={'center'}>
        {'Electronic Trading is currently unavailable.'}
      </HeadingS>
      <HeadingS textAlign={'center'}>
        <HeadingS>{'In the meantime, please call the desk at'}</HeadingS>
        <HeadingS color={'$brand400'}>{' 212-824-0734 '}</HeadingS>
        <HeadingS>{'for any trade inquiries.'}</HeadingS>
      </HeadingS>
      <HeadingS textAlign={'center'}>{'Thank you.'}</HeadingS>
    </YStack>
  );
};

export { MaintenanceBottomSheetContent };
